import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { CustomerServices } from "../../../core/services/CustomerServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Customers.css";
import { useSelector } from "react-redux";
import {
  customerTypeObjArr,
  genderObjArr,
  onOffArr,
  ratingObjArr,
  religionObjArr,
  retentionTypeObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import {
  displayDateMonthField,
  displayDateTimeField,
  displayField,
  getLabelFor,
  getPrimaryAddress,
  isNotEmpty,
} from "../../../utils/helpers";
import { get } from "lodash/fp";

const ViewCustomerModal = (props: any) => {
  const { t } = useTranslation();
  const userActionData = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [customerInfo, setCustomerInfo] = useState<any>({});
  const [address, setAddress] = useState<any>({});
  async function getViewCustomerDetail(id: number) {
    try {
      setLoader(true);
      const res = await CustomerServices.viewCustomer(id);
      const respData = get("data.data", res);
      const primaryAddress = getPrimaryAddress(respData.user);
      setCustomerInfo({ ...respData });
      setAddress(primaryAddress);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    let customerId = userActionData;
    getViewCustomerDetail(customerId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
        size="md"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("CUSTOMER")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="customers view-customers">
            <Container className="container">
              {customerInfo && Object.keys(customerInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <div className="view-usr-profile text-center mb-2">
                      <div>
                        <img
                          src={
                            customerInfo && customerInfo?.user?.image_url
                              ? customerInfo.user?.image_url
                              : UtilityServices.getLoggedInUser(
                                  "user_default_image"
                                )
                          }
                          alt={displayField(`${customerInfo?.user?.name}`)}
                          title={displayField(`${customerInfo?.user?.name}`)}
                        />
                      </div>
                    </div>
                    <div className="d-flex cst-dtl-mdl">
                      <Form.Group controlId="fname">
                        <Form.ControlLabel>
                          {t("FIRST_NAME")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.user?.fname}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="lname">
                        <Form.ControlLabel>
                          {t("LAST_NAME")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.user?.lname}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="email">
                        <Form.ControlLabel>{t("EMAIL")} : </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.user?.email}`)}{" "}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="mobile">
                        <Form.ControlLabel>{t("MOBILE")} : </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.user?.mobile}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="gender">
                        <Form.ControlLabel>{t("GENDER")} : </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(
                            getLabelFor(
                              customerInfo?.user?.gender,
                              genderObjArr
                            )
                          )}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="birthday">
                        <Form.ControlLabel>
                          {t("BIRTHDAY")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayDateMonthField(customerInfo?.user?.birthday)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="anniversary">
                        <Form.ControlLabel>
                          {t("ANNIVERSARY")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayDateMonthField(
                            customerInfo?.user?.anniversary
                          )}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="username">
                        <Form.ControlLabel>
                          {t("USERNAME")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.user?.username}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="store_name">
                        <Form.ControlLabel>
                          {t("STORE")} {t("NAME")}:
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.store?.store_name}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="customer_type">
                        <Form.ControlLabel>
                          {t("CUSTOMER")} {t("TYPE")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(
                            getLabelFor(
                              customerInfo?.customer_type,
                              customerTypeObjArr
                            )
                          )}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="retention_type">
                        <Form.ControlLabel>
                          {t("RETENTION")} {t("TYPE")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(
                            getLabelFor(
                              customerInfo?.retention_type,
                              retentionTypeObjArr
                            )
                          )}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="category_names">
                        <Form.ControlLabel>
                          {t("CATEGORY")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.category_names}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="customer_rating">
                        <Form.ControlLabel>{t("RATING")} : </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(
                            getLabelFor(
                              customerInfo?.customer_rating,
                              ratingObjArr
                            )
                          )}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="customer_detail">
                        <Form.ControlLabel>{t("DETAIL")} : </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.customer_detail}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="profession">
                        <Form.ControlLabel>
                          {t("PROFESSION")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.user?.profession}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="designation">
                        <Form.ControlLabel>
                          {t("DESIGNATION")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.user?.designation}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="created_by">
                        <Form.ControlLabel>
                          {t("CREATED")} {t("BY")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${customerInfo?.created_by?.name}`)}{" "}
                          {t("ON")}{" "}
                          {displayDateTimeField(`${customerInfo?.created_at}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="receive_notification">
                        <Form.ControlLabel>
                          {t("RECEIVE_NOTIFICATION")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {customerInfo?.user?.receive_notification ===
                          onOffArr.on
                            ? t("YES")
                            : t("NO")}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="status">
                        <Form.ControlLabel>{t("STATUS")} : </Form.ControlLabel>
                        <Form.ControlLabel>
                          {customerInfo?.status == onOffArr.on
                            ? t("ACTIVE")
                            : t("INACTIVE")}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="religion">
                        <Form.ControlLabel>
                          {t("RELIGION")} :{" "}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(
                            getLabelFor(
                              customerInfo?.user?.religion,
                              religionObjArr
                            )
                          )}
                        </Form.ControlLabel>
                      </Form.Group>
                    </div>

                    <h5 className="text-center mb-3">
                      {t("ADDRESS")} ({t("PRIMARY")})
                    </h5>
                    <div className="d-flex cst-dtl-mdl">
                      <Form.Group controlId="house_no">
                        <Form.ControlLabel>{t("HOUSE_NO")}</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.house_no}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="building">
                        <Form.ControlLabel>{t("BUILDING")}</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.building_name}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="landmark">
                        <Form.ControlLabel>{t("LANDMARK")}</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.landmark}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="area_name">
                        <Form.ControlLabel>{t("AREA")}</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.area_name}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="address_mobile">
                        <Form.ControlLabel>
                          {t("ADDRESS_MOBILE")}
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.mobile}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="pincode">
                        <Form.ControlLabel>{t("PINCODE")}</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.pincode}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="city_id">
                        <Form.ControlLabel>{t("CITY")} :</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.city?.city_name}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="state_id">
                        <Form.ControlLabel>{t("STATE")} :</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.state?.state_name}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                      <Form.Group controlId="country_id">
                        <Form.ControlLabel>{t("COUNTRY")} :</Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(`${address?.country?.country_name}`)}
                        </Form.ControlLabel>
                      </Form.Group>
                    </div>
                    {/* <ButtonToolbar className="btn-center">
                      <Button
                        onClick={() => props?.toggle("")}
                        color="red"
                        appearance="primary"
                      >
                        Close
                      </Button>
                    </ButtonToolbar> */}
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewCustomerModal;
